import React from 'react'

import { MenuItems } from '@peracto/peracto-blocks-tailwind'
import Form from './Form/MenuItemsForm'
import { defaultSettings } from './defaults/settings'

const createPlugin = settings => {
    const mergedSettings = { ...defaultSettings, ...settings }
    const RenderComponent = MenuItems

    return {
        FormComponent: props => <Form {...props} />,
        Component: props => <RenderComponent.Component {...props} {...mergedSettings} />,

        name: 'peracto/content/menuItems',
        version: '1.0.0',
        text: mergedSettings.translations.pluginName,
        description: mergedSettings.translations.pluginDescription,
        IconComponent: mergedSettings.IconComponent,

        createInitialState: () => ({
            menu: {},
            menuItem: {},
            menuItemPath: null,
            categoryPath: null,
        }),
    }
}

export default createPlugin
